import { Col } from 'reactstrap';
import styled from 'styled-components';
import { color } from '~/assets/styles/colors';
// import { Link } from 'react-router-dom';

export const ContainerFooter = styled.div`
	display: flex;
	width: 100%;
	align-items: center;
	justify-content: center;
	height: 120px;
	background-color: white;
	border-radius: 18px 18px 0 0;
	box-shadow: 2px -3px 12px ${color.grayMedium};

`;

export const ContentFooter = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 120px;
	cursor: pointer;
`;

export const ContentMenuItem = styled(Col)`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 120px;
	cursor: pointer;
`;


export const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	cursor: pointer;
`;

export const ContainerMenu = styled.div`
	background-color: rgba(255, 255, 255, 0.9);
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	border-radius: 12px 12px 0px 0px;
	flex-direction: column;
	justify-content: center;
	max-height: 100%;
	padding-bottom: 20px;
	margin-bottom: 80px;
	z-index: 9999 !important;
`;

export const ImgDivFooter = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;

	.menu-icon{
		margin-top: -35px;
		padding: 10px 12px 13px 13px;
		border-radius: 100%;
		border: 3px solid ${color.grayMedium};
		color: ${color.softBlack};
		transition: all ease 0.5s;
	}

	.menu-active{
		margin-top: -35px;
		padding: 10px 12px 13px 13px;
		border-radius: 100%;
		border: 3px solid ${color.primary};
		background-color: ${color.primary};
		color: white;
		transition: all ease 0.5s;
	}
`;

export const ImgFooter = styled.img``;

export const TextDivFooter = styled.div`
	display: flex;
	font-size: 12px;
	width: 100%;
	height: 100%;
	text-align: center;
	justify-content: center;
`;

export const TextFooter = styled.text``;
